import { success, failure, request } from 'app/actions';
import * as actions from './simulatedContentMapActions';
import * as helpers from './simulatedContentMapHelpers';

const initialState = {
  isCoordinator: { permission: null, edit: null },
  showReports: false,
  showReportsTRI: false,
  contract: {},
  classesOptions: [],
  curricularOptions: [],
  curricularAbilityOptions: [],
  contentOptions: [],
  keywordOptions: [],
  unitsOptions: [],
  unitsAbilityOptions: [],
  evaluation: {
    catalogings: [],
    idString: '',
  },
  abilities: [],
  abilitiesFiltered: [],
  approveAllStatus: {},
  stepConcluded: false,
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case request(actions.CHECK_COORDINATOR_PERMISSION):
      return {
        ...state,
        isCoordinator: initialState.isCoordinator,
        showReports: initialState.showReports,
        showReportsTRI: initialState.showReportsTRI,
        loading: true,
      };
    case failure(actions.CHECK_COORDINATOR_PERMISSION):
      return {
        ...state,
        isCoordinator: initialState.isCoordinator,
        showReports: initialState.showReports,
        showReportsTRI: initialState.showReportsTRI,
        loading: false,
      };
    case success(actions.CHECK_COORDINATOR_PERMISSION):
      return {
        ...state,
        isCoordinator: action.payload.contents.isCoordinator,
        showReports: action.payload.contents.showReports,
        showReportsTRI: action.payload.contents.showReportsTRI,
        loading: false,
      };
    case success(actions.GET_CLASSES_OPTIONS):
      return {
        ...state,
        classesOptions: helpers.getClassesOptions(action.payload.contents),
        loading: false,
      };
    case success(actions.GET_CURRICULAR_OPTIONS):
      return {
        ...state,
        curricularOptions: helpers.getCurricularOptions(action.payload.contents),
        loading: false,
      };
    case success(actions.GET_UNITS_OPTIONS):
      return {
        ...state,
        unitsOptions: helpers.getUnitsOptions(action.payload.contents),
        loading: false,
      };
    case request(actions.GET_EVALUATION_INFORMATION):
      return {
        ...state,
        evaluation: initialState.evaluation,
        contract: initialState.contract,
        loading: true,
      };
    case success(actions.GET_EVALUATION_INFORMATION):
      return {
        ...state,
        evaluation: helpers.getEvaluation(action.payload.content),
        contract: action.payload.content.contract,
        loading: false,
      };
    case request(actions.GET_CURRICULAR_ABILITY_OPTIONS):
      return {
        ...state,
        curricularAbilityOptions: initialState.curricularAbilityOptions,
        keywordOptions: initialState.keywordOptions,
        loading: true,
      };
    case success(actions.GET_CURRICULAR_ABILITY_OPTIONS):
      return {
        ...state,
        curricularAbilityOptions: helpers.getCurricularOptions(action.payload.contents),
        loading: false,
      };
    case success(actions.GET_UNITS_ABILITY_OPTIONS):
      return {
        ...state,
        unitsAbilityOptions: helpers.getUnitsOptions(action.payload.contents),
        loading: false,
      };
    case success(actions.GET_CONTENT_ABILITY_OPTIONS):
      return {
        ...state,
        contentOptions: helpers.getContentOptions(action.payload.contents),
        loading: false,
      };
    case success(actions.GET_KEYWORD_ABILITY_OPTIONS):
      return {
        ...state,
        keywordOptions: helpers.getKeywordOptions(action.payload.results),
        loading: false,
      };
    case success(actions.GET_HABILITIES):
      return {
        ...state,
        abilities: action.payload.content,
        abilitiesFiltered: action.payload.content,
        stepConcluded: action.payload.stepConcluded,
        loading: false,
      };
    case request(actions.APPROVE_ALL_ABILITIES):
    case actions.RESET_APPROVE_ALL_ABILITIES_STATUS:
      return {
        ...state,
        approveAllStatus: initialState.approveAllStatus,
        loading: true,
      };
    case failure(actions.APPROVE_ALL_ABILITIES):
      return {
        ...state,
        approveAllStatus: {
          error: true,
          message: action.payload.error || action.payload.message,
        },
        loading: false,
      };
    case success(actions.APPROVE_ALL_ABILITIES):
      return {
        ...state,
        approveAllStatus: {
          success: true,
          message: action.payload.message,
        },
        loading: false,
      };
    case actions.APPLY_FILTER:
      return {
        ...state,
        abilitiesFiltered: helpers.filterAbilities(state.abilities, action.payload),
      };
    case actions.CLEAR_FILTER:
      return {
        ...state,
        abilitiesFiltered: state.abilities,
      };
    default:
      return state;
  }
};

export default reducer;
